<template><div></div></template>

<script>
import { mapMutations } from "vuex";
import {mapState} from "vuex";
import {getResponse} from "@/util/utilities";

export default {
  name: "Logout",
  computed: {
    ...mapState(["user"])
  },
  mounted() {
    if(this.user){
      this.reset();
      this.$router.push({
        name: "Login"
      });
    }
    else {
      this.$router.push({
        name: "Login"
      });
    }
  },
  methods: {
    ...mapMutations({
      setLoggedIn: "SET_LOGGED_IN",
      setUser: "SET_USER",
      setToken: "SET_TOKEN",
      //setRoles: "SET_ROLES",
      setRols: "SET_ROLS",
      //setModules: "SET_MODULES",
      setAvailableLangs: "SET_AVAILABLE_LANGS"
    }),
    /*async verificarUsuario(){
      let data = new FormData();
      data.append("email", this.user.correo);

      let request = await this.$http.post(route("Usuarios/verificarUsuario"), data);
      return getResponse(request);
    },*/
    reset(){
      this.setLoggedIn(false);
      this.setUser(false);
      this.setToken(false);
      //this.setRoles([]);
      //this.setModules([]);
      this.setRols([]);
      this.setAvailableLangs([]);
      this.sendCloseSesion();
      EventBus.$emit("delete-messages");
    },
    async sendCloseSesion() {
            await this.$http
            .get(process.env.VUE_APP_CHAT_ENDPOINT + "/api/Chat/sesion/?edo=" + 1)
            .then(
            response => {
                // console.log(response);
                this.sendUser();
            },
            error => {
                console.error(error);
            });
        }
  }
};
</script>
